var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var Model = GenericModel.extend(
{
    urlRoot : '/rest/api/admin/logins',
    id : null,
    name : "",
    lastName: "",
    userName: "",
    hasActiveToken : "",
    venueName : "",
    organizationName : "",
    venueId : null,
    organizationId : null,
});

module.exports = Model;